export interface Route {
  link: string;
  title: string;
}

export const basicExample: Record<string, Route> = {
  start: { link: '/', title: 'Start' },
  download: { link: '/download', title: 'Download' },
  example: { link: '/quickstart', title: 'Quickstart' },
  templates: {
    link: '/corporate-design/templates',
    title: 'Templates',
  },
};

export const basicElements: Record<string, Route> = {
  colors: { link: '/basic-elements/colors', title: 'Farben' },
  logos: {
    link: '/basic-elements/wort-und-bildmarken',
    title: 'Wort-/Bildmarken',
  },
  typography: { link: '/basic-elements/typography', title: 'Typografie' },
};

export const formElements: Record<string, Route> = {
  forms: { link: '/basic-elements/formulare', title: 'Formulare' },
  form_validation: {
    link: '/basic-elements/form-validierung',
    title: 'Formular-Validierung',
  },
};

export const paasIntegration: Record<string, Route> = {
  tools_header: {
    link: '/basic-elements/tools-header',
    title: 'Tools-Header',
  },
  tools_footer: {
    link: '/basic-elements/tools-footer',
    title: 'Tools-Footer',
  },
  webdienst_header: {
    link: '/basic-elements/webdienst-header',
    title: 'Webdienst-Header',
  },
  webdienst_footer: {
    link: '/basic-elements/webdienst-footer',
    title: 'Webdienst-Footer',
  },
};
export const cookieIntegration: Record<string, Route> = {
  cookie_consent: {
    link: '/basic-elements/cookie-hinweis',
    title: 'Cookie-Hinweis',
  },
};

export const bsComponents: Record<string, Route> = {
  accordion: { link: '/components/accordion', title: 'Accordion' },
  alerts: { link: '/components/alerts', title: 'Alerts' },
  backtotop: { link: '/components/back-to-top', title: 'Back-To-Top' },
  badges: { link: '/components/badges', title: 'Badges' },
  buttons: { link: '/components/buttons', title: 'Buttons' },
  breadcrumbs: { link: '/components/breadcrumbs', title: 'Breadcrumbs' },
  carousel: { link: '/components/carousel', title: 'Carousel' },
  collapse: { link: '/components/collapse', title: 'Collapse' },
  dropdown: { link: '/components/dropdown', title: 'Dropdown' },
  images: { link: '/components/images', title: 'Images' },
  modal: { link: '/components/modal', title: 'Modal' },
  navtabs: { link: '/components/navtabs', title: 'Nav-Tabs' },
  offcanvas: { link: '/components/offcanvas', title: 'Offcanvas' },
  pagination: { link: '/components/pagination', title: 'Pagination' },
  popover: { link: '/components/popover', title: 'Popover' },
  progressbar: { link: '/components/progressbar', title: 'Progressbar' },
  icons: { link: '/components/icons', title: 'Icons' },
  spinner: { link: '/components/spinner', title: 'Loading spinner' },
  tables: { link: '/components/tables', title: 'Tables' },
  teaser: { link: '/components/teaser', title: 'Teasers' },
  testimonial: { link: '/components/testimonial', title: 'Testimonial' },
  tooltip: { link: '/components/tooltip', title: 'Tooltip' },
  videos: { link: '/components/videos', title: 'Videos' },
};

export const exampleIntegration = Object.entries(basicExample).slice(0, 4);
export const corporateDesign = Object.entries(basicElements).slice(0, 3);
export const forms = Object.entries(formElements).slice(0, 2);
export const paasSaas = Object.entries(paasIntegration).slice(0, 4);

export const components_1 = Object.entries(bsComponents).slice(0, 8);
export const components_2 = Object.entries(bsComponents).slice(8, 16);
export const components_3 = Object.entries(bsComponents).slice(16, 24);

export const cookieConsent = Object.entries(cookieIntegration).slice(0, 1);
